export default "__VITE_ASSET__C8ZkHRmB__"